import React, { useEffect } from 'react';
import '../styles/Television.css';
import Footer from '../components/Footer';

const Television = () => {
  useEffect(() => {
    // Initialize AOS (Animate On Scroll) - equivalent functionality
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observe all elements with data-aos attribute
    const animatedElements = document.querySelectorAll('[data-aos]');
    animatedElements.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(el);
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="television-page">
      {/* Hero Section with TV Background */}
      <div className="hero-section">
        {/* Background Image */}
        <div 
          className="hero-background"
          style={{
            backgroundImage: "url('/assets/img/tv-background.jpg')"
          }}
        ></div>
        
        {/* Overlay */}
        <div className="hero-overlay"></div>
        
        {/* Hero Content */}
        <div className="hero-content">
          <div className="container">
            <div className="row align-items-center min-vh-100">
              <div className="col-12 text-center">
                <h1 className="hero-title" data-aos="fade-up" data-aos-duration="1000">
                  TV Advertising Agency
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* TV Channels Section */}
      <section className="tv-channels-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="channels-title" data-aos="fade-up" data-aos-duration="1000">
                TV Advertisement Channels
              </h2>
              <div className="channels-description" data-aos="fade-up" data-aos-delay="200" data-aos-duration="1000">
                <p className="description-text">
                  ARK Moving Images creates powerful television ads that emotionally connect with audiences across all age groups. We produce ads in multiple regional languages like Tamil, Telugu, Malayalam, Kannada, and Hindi, and ensure they are broadcast at the right time to reach the right audience. From concept to distribution, our creative team handles the full process. With strategic media planning, we help your brand gain visibility, credibility, and reach—locally and globally—by placing ads on the most effective TV programs within your budget.
                </p>
              </div>
            </div>
          </div>
          <div className="tv-channels-grid">
            <div className="top-row">
              <div className="channel-card">
                <img src="/assets/img/Tv-ads-channels/new-tv.avif" alt="News TV" className="tv-channel-logo" />
                <h3 className="channel-name">News TV</h3>
              </div>
              
              <div className="channel-card">
                <img src="/assets/img/Tv-ads-channels/news-18.webp" alt="News 18 Tamil Nadu" className="tv-channel-logo" />
                <h3 className="channel-name">News 18 Tamil Nadu</h3>
              </div>
              
              <div className="channel-card">
                <img src="/assets/img/Tv-ads-channels/star-maa.jpg" alt="Star Maa" className="tv-channel-logo" />
                <h3 className="channel-name">Star Maa</h3>
              </div>
            </div>
            
            <div className="bottom-row">
              <div className="channel-card">
                <img src="/assets/img/Tv-ads-channels/tv-telangana.png" alt="TV Telangana" className="tv-channel-logo" />
                <h3 className="channel-name">TV Telangana</h3>
              </div>
              
              <div className="channel-card">
                <img src="/assets/img/Tv-ads-channels/colors-tamil.webp" alt="Colors Tamil" className="tv-channel-logo" />
                <h3 className="channel-name">Colors Tamil</h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TV Advertising Features Section */}
      <section className="tv-features-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="features-title">
                Why Choose TV Advertising?
              </h2>
              <p className="features-subtitle">
                Reach millions of viewers with our strategic TV advertising solutions
              </p>
            </div>
          </div>
          
          <div className="row g-4 mt-4">
            <div className="col-lg-4 col-md-6">
              <div className="tv-feature-card">
                <div className="tv-feature-icon">
                  <i className="fas fa-tv"></i>
                </div>
                <h3 className="tv-feature-title">Wide Reach</h3>
                <p className="tv-feature-description">
                  Access millions of viewers across multiple TV channels and time slots for maximum brand visibility.
                </p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="tv-feature-card">
                <div className="tv-feature-icon">
                  <i className="fas fa-target"></i>
                </div>
                <h3 className="tv-feature-title">Targeted Advertising</h3>
                <p className="tv-feature-description">
                  Precise audience targeting based on demographics, viewing habits, and regional preferences.
                </p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="tv-feature-card">
                <div className="tv-feature-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <h3 className="tv-feature-title">High Impact</h3>
                <p className="tv-feature-description">
                  Captivate audiences with high-quality video content that drives engagement and brand recall.
                </p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="tv-feature-card">
                <div className="tv-feature-icon">
                  <i className="fas fa-clock"></i>
                </div>
                <h3 className="tv-feature-title">Prime Time Slots</h3>
                <p className="tv-feature-description">
                  Secure premium time slots during peak viewing hours for maximum audience attention.
                </p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="tv-feature-card">
                <div className="tv-feature-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <h3 className="tv-feature-title">Multi-Language</h3>
                <p className="tv-feature-description">
                  Create ads in multiple regional languages to connect with diverse audiences effectively.
                </p>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <div className="tv-feature-card">
                <div className="tv-feature-icon">
                  <i className="fas fa-award"></i>
                </div>
                <h3 className="tv-feature-title">Professional Quality</h3>
                <p className="tv-feature-description">
                  High-end production values with professional editing and post-production for polished results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TV Advertising Process Section */}
      <section className="tv-process-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="process-title">
                Our TV Advertising Process
              </h2>
              <p className="process-subtitle">
                From concept to broadcast - we handle everything
              </p>
            </div>
          </div>
          
          <div className="tv-process-cards-container">
            <div className="tv-advertising-process-card">
              <div className="tv-process-card-number">01</div>
              <h3 className="tv-process-card-title">Strategy & Planning</h3>
              <p className="tv-process-card-description">
                We analyze your target audience and develop a comprehensive TV advertising strategy.
              </p>
            </div>
            
            <div className="tv-advertising-process-card">
              <div className="tv-process-card-number">02</div>
              <h3 className="tv-process-card-title">Creative Development</h3>
              <p className="tv-process-card-description">
                Our creative team designs compelling video content that resonates with your audience.
              </p>
            </div>
            
            <div className="tv-advertising-process-card">
              <div className="tv-process-card-number">03</div>
              <h3 className="tv-process-card-title">Production</h3>
              <p className="tv-process-card-description">
                High-quality video production with professional equipment and experienced crew.
              </p>
            </div>
            
            <div className="tv-advertising-process-card">
              <div className="tv-process-card-number">04</div>
              <h3 className="tv-process-card-title">Broadcast & Monitoring</h3>
              <p className="tv-process-card-description">
                Strategic placement across TV channels with continuous monitoring and optimization.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Television;
